

const WordofWisdomeCard = () => {
    return (

        <>

            {/* <!--Sidebar Page Container--> */}
            <div className="sidebar-page-container">
                <div className="auto-container">
                    <div className="row clearfix">

                        {/* <!--Content Side / Blog Detail--> */}
                        <div className="content-side col-lg-12 col-md-12 col-sm-12">
                            <div className="post-details">
                                {/* <!--Blog Details--> */}
                                <div className="blog-details">


                                    <div className="lower-box">


                                        <div className="panel panel-primary">
                                            <div className="panel panel-heading">
                                                <h4>Words of Wisdom - Question & Answer Session - #136 </h4>
                                            </div>

                                            <div className="panel panel-body">
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                        {/* <!--<p> <img src="images/wordofwisdom.jpg" /></p>--> */}

                                                        <p> Dear readers, it is my utmost pleasure to present a series of Q&amp;A
                                                            sessions between Shri Maharaj Ji and devotees. </p>
                                                        <p> <strong> Devotee:</strong> Maharaj Ji, what is the aim of the individual soul?</p>
                                                        <p>
                                                            <strong> Maharaj Ji:</strong> Every discerning individual must decide that our aim in life is to serve the Supreme Lord Shri Krishna for His pleasure. Serving God to please oneself is not genuine service. All individual souls are eternal servants of their source, Shri Krishna. We observe in nature that all the parts of a tree are always serving the tree. The roots, branches, sub-branches and leaves are always busy serving the tree, because they are part of the tree. Roots take necessary nutrients from the earth and provide them to the tree. Branches and leaves also serve the tree by bringing it oxygen and sunshine.

                                                            <br/>
                                                            We too are part and parcel of Shri Krishna and must serve Him with heart and soul. This is the aim of every individual soul.
                                                           
                                                           
                                                           
                                                      </p>

                                                       <p> <strong> Devotee:</strong> Maharaj Ji, whom should we serve?  </p> 

                                            
 
                                                         <p> <strong> Maharaj Ji:</strong> We should serve Shri Krishna. Every living being in existence desires ‘Anand’, unlimited and everlasting happiness. Everyone in the world desires only this ‘Anand’ and we are all slaves of this unlimited happiness. Shri Krishna and ‘Anand’ are synonymous, which means that every living being in creation is inadvertently a servant of Shri Krishna. He is the Source; we are His part and parcel. A part always desires the source. All rivers flow towards their source, ocean, and finally merge into it. Flames always rise upwards, towards the sun. Similarly, all individual souls are part and parcel of God and therefore it is our natural nature to attain Him.
                                                         <br/>
                                                         The material world is made of five gross elements: space, air, fire, water, and earth. Our body is also made of the same five elements. This puts the world and our body in the same category. Our body needs things of the world. The soul is divine and it is a fraction of God. Therefore, Shri Krishna is the one we should serve.
                                                       </p>


                                                        <p> <strong> Devotee:</strong>Maharaj Ji, people say that a stone in the holy river Ganga becomes purified. Likewise, a person who dies in Vrindavan attains liberation even without practicing devotion. Is this true? </p> 
                                                        <p> <strong> Maharaj Ji:</strong>No; liberation cannot be attained without the practice of devotion.  </p> 


                                                          

                                                           


                                                       

                                                        
                                                     

                                                        <hr />
                                                        <p> Yours,</p>
                                                        <p> Didi Ji</p>
                                                        <p className="text-center"> Note: You may direct your spiritual questions to me
                                                            directly at</p>
                                                        <p className="text-center"> s_didi@radhamadhavsociety.org</p>


                                                    </div>

                                                </div>

                                            </div>


                                        </div>




                                    </div>






                                </div>





                            </div>

                        </div>


                    </div>
                </div>
            </div>
            {/* <!-- End Sidebar Page Container --> */}



        </>


    )

}

export default WordofWisdomeCard;